<template>
    <div>
        <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="true"></b-loading>
        <div class="columns is-multiline card">
            <ItemList
            :prodDetailUrl="prodDetailUrl"
            :order="order"/>
            <Bill
            :order="order"/>
            <MPPaymentDetail
            :order="order"
            />
            <DeliveryDateDetails
            v-if="deliveryDateControl == 'True'"
            :order="order"/>
            <CustomData
            v-if="order.customData.length"
            :order="order"
            :sectionName="customSectionName"
            />
            <Controls
            :order="order"
            @updateOrder="updateObj"/>
        </div>
    </div>
</template>

<script>
import { getHandler, patchHandler } from '../../../services/http';
import ItemList from "./components/ItemList.vue";
import Bill from "./components/Bill.vue";
import Controls from "./components/Controls.vue";
import CustomData from "./components/CustomData.vue"
import DeliveryDateDetails from "./components/DeliveryDateDetails.vue"
import MPPaymentDetail from "./components/MPPaymentDetail.vue"
export default {
    components:{
        ItemList,
        Bill,
        Controls,
        CustomData,
        DeliveryDateDetails,
        MPPaymentDetail
    },
    props:{
        detailUrl:{
            type:String,
            default:""
        },
        prodDetailUrl:{
            type:String,
            default:""
        },
        customSectionName:{
            type:String,
            default:""
        },
        deliveryDateControl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            order:{},
        }
    },
    methods:{
        async fetchDetails(){
            this.loading = true
            this.order = await getHandler(this.detailUrl, {error:false, success:false})
            this.loading = false
        },
        async updateObj(notify){
            this.loading = true
            let url = this.detailUrl
            if(notify){
                url = this.detailUrl + "?notify=yes"
            }
            let msg = {resource:"notify"}
            let res = await patchHandler(url, this.order, {error:msg, success:msg})
            this.fetchDetails()
        }
    },
    created(){
        this.fetchDetails()
    }
}
</script>

<style lang="scss" scoped>
.card{
    border:0px #fff solid !important;
    border-radius: 20px;
    box-shadow: 1px 10px 10px rgba(184, 184, 184, 0.55);
}
</style>